<template>
  <el-dialog :title="settingDialog.titleName"
    :width="settingDialog.dialogWidth"
    :before-close="handleClose"
    class="base-dialog"
    :class="settingDialog.activeClass"
    modal-append-to-body
    append-to-body
    :visible="showDialog"
    @update:visible="$emit('update:showDialog')"
    >
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean
    },
    settingDialog: {
      type: Object,
      require: true,
      dialogWidth: {
        default: "36%"
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    settingDialog: {
      handler(newValue, old) {
        console.log(newValue);
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="stylus">
.base-dialog{
  
  .el-dialog__body{
    padding:20px 70px;
  }
  .el-dialog__headerbtn{
    top:0;
    line-height 54px;
  }
  .el-dialog{
    border-radius:6px;
    overflow hidden;
  }
  .el-icon-close:before {
    width:13px;
    height:13px;
    color:white;
  }
  .el-dialog__header{
    overflow hidden;
    padding:0 0 0 32px;
    line-height :54px;
    background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
    .el-dialog__title{
      font-size:18px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
      text-shadow:0px 1px 0px rgba(7,86,177,0.58);
    }
  }
}
</style>
